import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";

const Login = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  // Local development talks directly to the production API instead of CRA's localhost proxy.
  const apiOrigin = process.env.REACT_APP_API_ORIGIN || "";
  const apiBase = `${apiOrigin.replace(/\/$/, "")}/${id}/v3`;

  const [email, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [school, setSchool] = useState({});

  const togglePassword = () => {
    setPasswordType((prev) => (prev === "password" ? "text" : "password"));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setStatus(true);
    try {
      const response = await axios.post(`${apiBase}/login`, { email, password });
      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        const decodedToken = jwtDecode(response.data.token);
        toast.success("Success: Login successful!");
        setTimeout(() => {
          setStatus(false);
          navigate("./verify-otp", { state: { user: decodedToken } });
        }, 2000);
      } else throw new Error("Invalid Credentials");
    } catch (error) {
      toast.error("Login Failed! Incorrect details.");
      setStatus(false);
    }
  };

  const fetchSchool = async () => {
    try {
      const response = await axios.post(`${apiBase}/school`, { school_id: id });
      if (!response.data || !response.data.schoolname) throw new Error();
      setSchool(response.data);
      localStorage.setItem("schoolname", response.data.schoolname);
    } catch {
      navigate("/nopage");
    }
  };

  useEffect(() => {
    fetchSchool();
  }, [id]);

  return (
    <div className="d-lg-flex min-vh-100">
      {/* Left - Form Section */}
      <div className="col-md-6 d-flex flex-column px-6 px-lg-5 py-lg-4 py-4 mt-n2 mt-lg-o bg-white position-relative">
        {/* 🔹 Logo and Name */}
        <div className="mb-5 d-flex align-items-center mb-8 ms-n4 ms-lg-0">
          <span className="fs-t2 fw-medium text-dark">{school.schoolname}</span>
        </div>

        {/* 🔹 Center the form vertically */}
        <div
          className="flex-grow-1 d-flex flex-column justify-content-center"
          style={{ maxWidth: "400px", margin: "0 auto", width: "100%" }}
        >
          <div>
            <div className="mb-4 fw-medium fs-t text-purple">Admin Dashboard</div>

            <form onSubmit={handleLogin}>
              <div className="form-group mb-6 mb-lg-4">
                <input
                  type="email"
                  className="form-control form-control-lg bg-back rounded-pill"
                  placeholder="Enter your mail"
                  required
                  value={email}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>

              <div className="form-group mb-3 position-relative">
                <input
                  type={passwordType}
                  className="form-control form-control-lg bg-back rounded-pill"
                  placeholder="Enter your password"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  className="position-absolute end-0 top-50 translate-middle-y me-3 cursor-pointer"
                  onClick={togglePassword}
                >
                  <i
                    className={`bi ${
                      passwordType === "password"
                        ? "bi-eye-fill"
                        : "bi-eye-slash-fill"
                    }`}
                  ></i>
                </span>
              </div>

              <div className="form-check mb-0"></div>

              <button
                type="submit"
                className="btn btn-purple btn-lg w-100 rounded-pill mb-3"
                disabled={status}
              >
                {status ? "Logging in..." : "Sign In"}
              </button>
            </form>

            <p className="text-center">
              Remember we would always keep your data safe and secure.
            </p>
          </div>
        </div>
      </div>

      {/* Right - Analytics Side */}
      <div className="col-md-6 d-flex flex-column justify-content-center align-items-center bg-purple4 text-white px-6 px-lg-5 py-lg-4 py-6">
        <div className="text-center">
          <img
            src="../assets/images/background/log.png"
            alt="Analytics"
            className="img-fluid mb-4"
            width={"100%"}
          />
          <div className="text-white fs-3 fw-medium mb-3">Very simple way you can engage</div>
          <p className="text-white fs-4 mb-0">
            Access All At Ease <b>Now!</b> The School Management System Made Just For You! <br/> 1, 2, 3, <b>Online.</b>
          </p>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default Login;
